import { $t } from '../../../../../_metronic/i18n/formatMessage';
import { SeparatorLines } from '../../../../shared/Lines';
import { useFormikContext } from 'formik';
import { Input } from '../../../../shared/Input';
import { FormattedMessage } from 'react-intl';

export default function StepInvoicesConfigurations() {
  const formik = useFormikContext<any>();

  return (
    <div className='table-wrapper card mt-10'>
      <div className='table-wrapper bg-white pb-10'>
        <h3 className='m-2 mx-5'>{$t('Invoices configurations')}</h3>
        <SeparatorLines lines={2} />
        <div className='p-10 ' style={{ width: '100%' }}>
          <div className='row fv-row'>
            <label className='d-flex flex-column mb-0 cursor-pointer'>
              <span className='d-flex align-items-center m-2'>
                <span className='form-switch form-switch-custom form-switch-solid me-3'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    role='switch'
                    name='invoice_number_method'
                    checked={formik.values?.invoice_number_method === '2' ? true : false}
                    onChange={(event: any) => {
                      formik.setFieldValue(
                        'invoice_number_method',
                        event.target.checked ? '2' : '1'
                      );
                    }}
                    disabled
                    id='invoice_number_method'
                  />
                </span>

                <span className='d-flex flex-column'>
                  <span className='fw-bolder text-gray-800 text-hover-primary fs-5'>
                    {formik.values?.invoice_number_method === '1' && (
                      <FormattedMessage id='Manual: invoices will be generated through system with an invoice number entered manually for invoice that are created or uploaded from excel sheet.' />
                    )}
                    {formik.values?.invoice_number_method === '2' && (
                      <FormattedMessage id='Sequential: invoices will be generated through the system with a sequential invoice number that is auto-generated for each issued invoice that can only be created through the system.' />
                    )}
                  </span>
                </span>
              </span>
            </label>
          </div>
          <>
            <span className='d-flex flex-column'>
              <span className='fw-bolder text-gray-800 text-hover-primary fs-5 m-5'>
                {<FormattedMessage id='To enable E-invoicing module, please contact support.' />}
              </span>
            </span>
          </>
          <div className='row mb-10'>
            <div className='content-wrapper bg-white b-radius-25 mt-10'>
              <div className='d-flex px-5 '>
                <div
                  className='d-flex justify-content-center px-10 py-3 fs-6 '
                  style={{ width: '100%' }}
                >
                  <FormattedMessage id='Sales invoices' />
                </div>
              </div>
              <SeparatorLines lines={2} />
              <div className='row fv-row m-10 '>
                <div className='col-md-6'>
                  <Input
                    placeholder={$t('Prefix code')}
                    autoComplete='off'
                    labelId={$t('Prefix code')}
                    name={`sales_invoice_number_prefix`}
                    disabled
                    type='text'
                    formik={formik}
                    required
                  />
                </div>
                <div className='col-md-6'>
                  <Input
                    placeholder={$t('Invoices start number')}
                    autoComplete='off'
                    labelId={$t('Invoices start number')}
                    name={`sales_invoice_number_start`}
                    disabled
                    type='text'
                    formik={formik}
                    required
                  />
                </div>
              </div>
            </div>

            <div className='content-wrapper bg-white b-radius-25 mt-10'>
              <div className='d-flex px-5 '>
                <div
                  className='d-flex justify-content-center px-10 py-3 fs-6 '
                  style={{ width: '100%' }}
                >
                  <FormattedMessage id='Return sales invoices' />
                </div>
              </div>
              <SeparatorLines lines={2} />
              <div className='row fv-row m-10 '>
                <div className='col-md-6'>
                  <Input
                    placeholder={$t('Prefix code')}
                    autoComplete='off'
                    labelId={$t('Prefix code')}
                    name={`return_sales_invoice_number_prefix`}
                    disabled
                    type='text'
                    formik={formik}
                    required
                  />
                </div>
                <div className='col-md-6'>
                  <Input
                    placeholder={$t('Invoices start number')}
                    autoComplete='off'
                    labelId={$t('Invoices start number')}
                    name={`return_sales_invoice_number_start`}
                    disabled
                    type='text'
                    formik={formik}
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
